import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from 'common/store';
import { COMPANY_ROUTE_SLUGS, FIRM_ROUTE_SLUGS, FUND_ROUTES, TITLE_CONFIG } from './constants/titles';
import {
  extractDateFromUrl,
  getPageNameFromRouteType,
  getRouteType,
} from './routeHelpers';
import { useTitle } from './useTitle';

/**
 * Component that automatically updates the browser tab title based on the current route
 */
export const TitleUpdater = () => {
  const location = useLocation();
  const { updateMultiple } = useTitle();
  const [{ firmInfo, fundInfo, companyInfo }] = useStore();

  // Analyze the current route and extract information
  const routeType = getRouteType(location.pathname);
  const pageName = getPageNameFromRouteType(routeType);
  const measurementDate = extractDateFromUrl(location.search);

  // Extract firm/company names based on route type
  let firmOrCompanyName = '';
  const isCompanyRoute = COMPANY_ROUTE_SLUGS.includes(routeType);
  const isFirmRoute = FIRM_ROUTE_SLUGS.includes(routeType);
  const isFundRoute = FUND_ROUTES.includes(routeType as (typeof FUND_ROUTES)[number]);

  if (isCompanyRoute) {
    firmOrCompanyName = companyInfo?.name || '';
  } else if (isFirmRoute) {
    firmOrCompanyName = firmInfo?.name || '';
  } else if (isFundRoute) {
    firmOrCompanyName = fundInfo?.name || '';
  }

  // Update context and document title
  useEffect(() => {
    // Update the context
    updateMultiple({
      firmOrCompanyName,
      pageName,
      measurementDate,
    });

    // Update document title
    const titleParts = [firmOrCompanyName, pageName, measurementDate].filter(Boolean);
    const newTitle = titleParts.length > 0 ? titleParts.join(TITLE_CONFIG.SEPARATOR) : TITLE_CONFIG.DEFAULT_TITLE;
    document.title = newTitle;
  }, [firmOrCompanyName, pageName, measurementDate, updateMultiple]);

  return null; // This component doesn't render anything
};
